/* Pilatoes gallery — swipe track + thumbnail strip.
   Hand-built, so it owes nothing to the theme's own media-gallery component.

   Markup contract (see pilatoes-product.liquid):
     <pilatoes-gallery>
       [data-plt-track]  scroll-snap container, one [data-plt-slide] per media
       [data-plt-thumbs] optional strip of <button data-plt-thumb data-index="n">
       [data-plt-dots]   optional row of <button data-plt-dot data-index="n">
       [data-plt-count]  optional "2 / 5" readout
*/
(function () {
  if (window.customElements && customElements.get('pilatoes-gallery')) return;

  class PilatoesGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-plt-track]');
      if (!this.track) return;
      this.slides = Array.from(this.track.querySelectorAll('[data-plt-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-plt-thumb]'));
      this.dots = Array.from(this.querySelectorAll('[data-plt-dot]'));
      this.countEl = this.querySelector('[data-plt-count]');
      this.index = 0;

      this.thumbs.concat(this.dots).forEach((btn) => {
        btn.addEventListener('click', () => this.goTo(Number(btn.dataset.index), true));
      });

      // Active slide is whichever is nearest the track's centre after scrolling settles.
      this._onScroll = () => {
        if (this._raf) cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(() => this.sync());
      };
      this.track.addEventListener('scroll', this._onScroll, { passive: true });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') this.goTo(this.index + 1, true);
        if (event.key === 'ArrowLeft') this.goTo(this.index - 1, true);
      });

      this.sync();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this._onScroll);
    }

    nearest() {
      const mid = this.track.scrollLeft + this.track.clientWidth / 2;
      let best = 0;
      let bestGap = Infinity;
      this.slides.forEach((slide, i) => {
        const gap = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - mid);
        if (gap < bestGap) {
          bestGap = gap;
          best = i;
        }
      });
      return best;
    }

    goTo(index, smooth) {
      const max = this.slides.length - 1;
      const next = Math.max(0, Math.min(max, index));
      const slide = this.slides[next];
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      this.setIndex(next);
    }

    sync() {
      this.setIndex(this.nearest());
    }

    setIndex(index) {
      this.index = index;
      this.thumbs.forEach((btn, i) => {
        const on = i === index;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-current', on ? 'true' : 'false');
      });
      this.dots.forEach((btn, i) => {
        btn.classList.toggle('is-active', i === index);
      });
      if (this.countEl) {
        this.countEl.textContent = index + 1 + ' / ' + this.slides.length;
      }
      // Keep the active thumbnail in view without touching page scroll.
      const thumb = this.thumbs[index];
      if (thumb && thumb.parentElement) {
        const strip = thumb.parentElement;
        const left = thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2;
        strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }
  }

  customElements.define('pilatoes-gallery', PilatoesGallery);
})();
